import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { faPlus, faAngleLeft, faAngleRight, faCheckCircle, faInfoCircle, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
//import { FormGroup, FormBuilder, FormArray, FormControl, Validators } from '@angular/forms';
import { isNullOrEmpty, isNullOrUndefined, isNullOrUndefinedObject } from 'src/app/helper/validation';
import { ProjectService } from '../project.service';
import { UserInfoService } from '../../user-info/user-info.service';
import { CalculateService } from '../../helper/calculate/calculate.service';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../helper/shared/shared.service';
import { ConfirmationdialogueService } from '../../confirmationdialogue/confirmationdialogue.service';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { createPopper } from '@popperjs/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectComponent } from '../project.component';
import { empty, EMPTY, of } from 'rxjs';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router'; //Modified by PP(2023-10-24): Check for timeout of logincode

@Component({
    selector: 'app-solution',
    templateUrl: './solution.component.html',
    styleUrls: ['./solution.component.scss']
})

export class SolutionComponent implements OnInit {
    @Output() nextStep = new EventEmitter<String>();
    //@ViewChild('ChemicalMedia', {static: false} ) chemMediaModal : any;

    faPlus = faPlus;
    faAngleLeft = faAngleLeft;
    faAngleRight = faAngleRight;
    faCheckCircle = faCheckCircle;
    faInfoCircle = faInfoCircle;
    faSearch = faSearch;
    faTimes = faTimes;

    NumberFormat = '';
    loading: boolean;

    solutions: any;
    results: any;
    availableGas = [];
    contamination: any;
    //contamination = this.projectService.projectdetails.contamination;
    //solutions = this.projectService.getSolutionsForComparisonEmptyValueStructure();
    SolutionInfo: any;
    StagesInfo: any;
    AddSolutionInfo: any;
    UnitsFromUserData: any;

    //sourceUrl = 'https://cfss.camfil.net/cfss2/';
    //filterPhotoPath = this.sourceUrl + 'picture/';
    closeResult = '';
    filtersStep: number = 1;
    element;
    Stage: any;
    selSearchFilterBtn = 2;
    searchMode = "";
    allFilterGrp;
    filterGrp;
    //currentsolution = [];
    currentsolution: any;
    selFilter: any;
    selTypes: any;
    allFilters = [];
    Filters: any;
    loadingFilterList: boolean;
    ChemicalMediaList: any[];
    FilterChemicals: any[];
    AllDDLList: any;
    refreshIntervalId: any;
    gasChecked = [];

    showMolecularDisplayNameInCustomSizePage = '';
    showMolecularTypeInCustomSizePage = '';
    showMolecularNameInCustomSizePage = '';

    UserIsAdmin = false; //Modified by PP(2022-09-21) : Follow CLD 2.0 : CLD 3.0 MVP1.0 - If record found in ownersetting, this user is an admin
    selectedConcUnit = "";

    customMediaSizeForInput = this.projectService.getCustomMediaSizeEmptyvalueStructure();

    selectedShape: string = 'rectangle'; //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
    
    constructor(
        private confirmationDialogService: ConfirmationdialogueService,
        private projectService: ProjectService,
        private userInfoService: UserInfoService,
        private calculateService: CalculateService,
        public route: ActivatedRoute,
        public sharedService: SharedService,
        private cookieSvc: CookieService,
        private toastr: ToastrService,
        private modalService: NgbModal,
        public ProjectComponent: ProjectComponent,
        private router: Router //Modified by PP(2023-10-24): Check for timeout of logincode
    ) { }

    // In sequence : ngOnInit, ngAfterContentInit, ngAfterViewInit
    ngOnInit(): void {
        this.projectService.activePage = 4;
        this.loading = false;

        this.initiateList();

        if (this.route.snapshot.url[0].path.toLowerCase() == 'projectedit') {
            if (this.sharedService.blnLoadFromRecord == true) {
                this.projectService.listData = this.sharedService.listData;
                this.projectService.getProjectStructure(this.sharedService.loadFromDatabase);

                //no need results because its incomplete
                //let results={};
                //results = this.projectService.getSolResultsStructure(this.sharedService.importXMLData.Params.MCCLDResults);
                //this.projectService.projectdetails.results=results;

                //Get More Information for Solution Details after results structure is ready
                this.projectService.getMoreInfoForSolutionDetails();

                //Get More Information values for contamination classes
                this.getMoreInfoForContamination();

                //If incomplete then only blnLoadFromRecord = true
                this.sharedService.blnLoadFromRecord = false;
                if (this.projectService.projectdetails.results != undefined) {
                    if (this.projectService.projectdetails.results.solutionsResults != undefined) {
                        if (this.projectService.projectdetails.results.solutionsResults.length == 0) {
                            this.sharedService.blnLoadFromRecord = true;
                        }
                    } else {
                        this.sharedService.blnLoadFromRecord = true;
                    }
                } else {
                    this.sharedService.blnLoadFromRecord = true;
                }

                //Why Incomplete true this statement? It won't be able to calculate in Results page
                //if (this.sharedService.projectNotCalc) {
                //this.sharedService.blnLoadFromRecord = true; 
                //}

                if (this.projectService.projectdetails.solutions.length === 0 || this.projectService.projectdetails.solutions == undefined) {
                    this.ProjectComponent.prevStep();
                }

                if (this.projectService.projectdetails.contamination.gasDetails.length === 0) {
                    this.ProjectComponent.prevStep();
                }

                if (this.projectService.projectdetails.results === undefined) {
                    this.ProjectComponent.prevStep();
                }
            }
        } else if (this.route.snapshot.url[0].path.toLowerCase() == 'importxml' && this.sharedService.projectNotCalc == true) {
            if (this.sharedService.LoadingXML == true) {
                this.projectService.listData = this.sharedService.listData;
                this.projectService.getProjectStructure(this.sharedService.importXMLData);

                //no need results because its incomplete
                //let results={};
                //results = this.projectService.getSolResultsStructure(this.sharedService.importXMLData.Params.MCCLDResults);
                //this.projectService.projectdetails.results=results;

                //Get More Information for Solution Details after results structure is ready
                this.projectService.getMoreInfoForSolutionDetails();

                //Get More Information values for contamination classes
                this.getMoreInfoForContamination();

                if (this.projectService.projectdetails.solutions.length === 0 || this.projectService.projectdetails.solutions == undefined) {
                    this.ProjectComponent.prevStep();
                }

                if (this.projectService.projectdetails.contamination.gasDetails.length === 0) {
                    this.ProjectComponent.prevStep();
                }

                if (this.projectService.projectdetails.results === undefined) {
                    this.ProjectComponent.prevStep();
                }

                //this.getViewinReport();
                this.sharedService.LoadingXML = false;
            }
        }

        switch (this.userInfoService.userData.UserConcUnit) {
            case "ppb":
                this.selectedConcUnit = "ppb";
                break;
            case "mg/m³":
                this.selectedConcUnit = "mg/m³";
                break;
        }

        this.solutions = this.projectService.projectdetails.solutions;
        this.contamination = this.projectService.projectdetails.contamination;

        //Get Selected Gas from Contamination Page
        for (var x = 0; x < this.contamination.gasDetails.length; x++) {
            let tmp = {};
            if (this.contamination.gasDetails[x].contaminationType == 'Others') {
                if (this.contamination.gasDetails[x].otherGas) {
                    tmp = {
                        index: this.contamination.gasDetails[x].index, //Modified by PP(2023-06-07) : Allow same gas diff conc value
                        chemicalID: this.contamination.gasDetails[x].chemicalID,
                        chemicalName: 'Others - ' + this.contamination.gasDetails[x].otherGasDetails.otherContaminantName,
                        concentrationValue: this.contamination.gasDetails[x].concentrationValue //Modified by PP(2023-06-07) : Allow same gas diff conc value
                    }
                    this.availableGas.push(tmp);
                }
            } else {
                if (this.contamination.gasDetails[x].chemicalID > 0) {
                    tmp = {
                        index: this.contamination.gasDetails[x].index, //Modified by PP(2023-06-07) : Allow same gas diff conc value
                        chemicalID: this.contamination.gasDetails[x].chemicalID,
                        chemicalName: this.contamination.gasDetails[x].contaminationType,
                        concentrationValue: this.contamination.gasDetails[x].concentrationValue //Modified by PP(2023-06-07) : Allow same gas diff conc value
                    }
                    this.availableGas.push(tmp);
                }
            }
        }

        if (this.projectService.projectdetails.solutions[this.projectService.projectdetails.solutions.length - 1].solutionDetails == undefined || this.projectService.projectdetails.solutions[this.projectService.projectdetails.solutions.length - 1].solutionDetails.length == 0) {
            //this.addSolution();
            this.addSolDetails(this.projectService.projectdetails.solutions.length - 1);
        }

        if (this.userInfoService.userData.NumberFormatId === 1) {
            this.NumberFormat = 'sv-SE';
        } else if (this.userInfoService.userData.NumberFormatId === 2) {
            this.NumberFormat = 'en-US';
        }

        //this.initiateList();
        this.initiateData();

        this.loadingFilterList = true;
        //this.toEnableDisableObj(1, 1, 'enable'); //Previously inside setTimeout in checkIfMediaCompletesLoading()
        //this.checkIfMediaCompletesLoading();

        //Trigger Calculation if changes from Contamination page been made
        if (this.projectService.generateResultRequired(true)) {   //change to airflow changes only       
            for (let i = 0; i < this.solutions.length; i++) {
                for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                    if (this.solutions[i].solutionDetails[j].molecularID > 0) {
                        //this.triggerCalculation(this.solutions[i].solutionID, this.solutions[i].solutionDetails[j].combinationID, true); //if from nooffilter then false
                    }
                }
            }
        }

        //Check if moreInformation is missing
        for (let i = 0; i < this.solutions.length; i++) {
            for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                var missingMoreInfo = 0;
                if (this.solutions[i].solutionDetails[j].moreInformation == undefined || this.solutions[i].solutionDetails[j].moreInformation == null) {
                    missingMoreInfo = 3;
                } else {
                    if (this.solutions[i].solutionDetails[j].moreInformation.contactTime === 0) {
                        missingMoreInfo = missingMoreInfo + 1;
                    }
                    if (this.solutions[i].solutionDetails[j].moreInformation.effectiveMediaWeight === 0) {
                        missingMoreInfo = missingMoreInfo + 1;
                    }
                    if (this.solutions[i].solutionDetails[j].moreInformation.frontVelocity === 0) {
                        missingMoreInfo = missingMoreInfo + 1;
                    }
                    if (this.solutions[i].solutionDetails[j].moreInformation.totalWeight === 0) {
                        missingMoreInfo = missingMoreInfo + 1;
                    }
                }

                if (missingMoreInfo > 2) { //at least 2 is zero then reload moreInfo
                    this.projectService.getMoreInfoForSolutionDetails();
                }
            }
        }
    }

    ngAfterContentInit() {
        //if(this.projectService.projectdetails.solutions.solutionDetails == undefined || this.projectService.projectdetails.solutions.solutionDetails.length == 0) {
        //this.addSolution();
        var bbb = 333;
        //}
    }

    ngAfterViewInit() {
        this.setPoppers();
        //if first run then 0. if comes from other pages then need to redo
        this.setEnableStageButtons();
        this.makeDefaultCSSForChemicalCheckBoxes(true, null, null, false, false);

        if (this.ChemicalMediaList == undefined && this.FilterChemicals == undefined) {
            this.toEnableDisableObj(1, 1, 'disable');
        }

        setTimeout(() => {
            this.sharedService.CalculationInProgress = false;
        }, 80);
    }

    initiateList() {
        this.AllDDLList = this.sharedService.listData;
        this.ChemicalMediaList = this.AllDDLList.AMCMolecularClass;
        this.FilterChemicals = this.AllDDLList.ChemicalFilters;

        // if (this.AllDDLList.AMCMolecularClass == undefined) {
        //     this.AllDDLList.AMCMolecularClass = this.sharedService.AMCMolecularClass;
        // }

        // if (this.AllDDLList.ChemicalFilters == undefined) {
        //     this.AllDDLList.ChemicalFilters = this.sharedService.ChemicalFilters;
        // }
    }

    //Modified by PS(2023-03-24): MCCLD 2023-Solution page: Fix bug - clear selected filter when gas changed-START
    /*initiateData() {
        //Modified by PP(2023-02-28) : Get from userino. If no data, then projectinfo - START
        // if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
        //     this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
        // } else {
        //     this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
        // }
    
        if (this.userInfoService.userData != null || this.userInfoService.userData != undefined) {
            if (this.userInfoService.userData.UserUnitId === this.sharedService.unitId_SI) {
                this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
            } else {
                this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
            }
            } else {
            if (this.projectService.projectdetails.projectInfo != null || this.projectService.projectdetails.projectInfo != undefined) {
                if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
                this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
                } else {
                this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
                }
            }
            }
            //Modified by PP(2023-02-28) : Get from userino. If no data, then projectinfo - END
    
        this.UserIsAdmin = this.sharedService.listData.UserCanUseExcel; //Modified by PP(2022-09-21) : Follow CLD 2.0 : CLD 3.0 MVP1.0 - If record found in ownersetting, this user is an admin
    
        //Default to More Information
        for (let i=0 ; i< this.solutions.length; i++) {
            for (let j=0 ; j< this.solutions[i].solutionDetails.length; j++) {
                this.solutions[i].solutionDetails[j].displayTypeForMoreInfo = 'More Information';
    
                //If load data, moreInformation is missing
                // pinky 2nd dec add. to test
    
                //Dont think i need this as results still here. Loadfromxml straight goes to Results then i click on Solutions
                // if (this.sharedService.importXMLData != undefined) {
                //     let results={};
                //     results = this.projectService.getSolResultsStructure(this.sharedService.importXMLData.Params.MCCLDResults);
                //     this.projectService.projectdetails.results=results;
                // }
            
                this.results = this.projectService.projectdetails.results.solutionsResults;
                if (this.solutions[i].solutionDetails[j].moreInformation == undefined) {
                    if (this.results != undefined) {
                        for (let y=0; y< this.results.length; y++) {
                            if (this.solutions[i].solutionID == this.results[y].solutionID) {
                                for (let z=0; z< this.results[y].results.length; z++) {
                                    if (this.solutions[i].solutionDetails[j].combinationID == this.results[y].results[z].combinationID) {                                   
                                        let newMoreInfoDetails = this.projectService.getMoreInfoForSolutionEmptyvalueStructure();
                                        newMoreInfoDetails.effectiveMediaWeight = this.sharedService.formatValue(parseFloat(this.results[y].results[z].effMediaWeight.toFixed(1)), true);                                       
                                        newMoreInfoDetails.frontVelocity = this.sharedService.formatValue(parseFloat(this.results[y].results[z].frontVelocity.toFixed(2)), true);                                   
                                        newMoreInfoDetails.totalWeight = this.sharedService.formatValue(parseFloat(this.results[y].results[z].totalWeight.toFixed(1)), true);                    
                                        newMoreInfoDetails.contactTime = this.sharedService.formatValue(parseFloat(this.results[y].results[z].contactTime.toFixed(2)), true);
                                        this.solutions[i].solutionDetails[j].moreInformation = newMoreInfoDetails;       
                                    }
                                }                              
                            }                           
                        } 
                    } else {
                        let newMoreInfoDetails = this.projectService.getMoreInfoForSolutionEmptyvalueStructure();
                        newMoreInfoDetails.effectiveMediaWeight = 0;                                       
                        newMoreInfoDetails.frontVelocity = 0;                                   
                        newMoreInfoDetails.totalWeight = 0;                    
                        newMoreInfoDetails.contactTime = 0;
                        this.solutions[i].solutionDetails[j].moreInformation = newMoreInfoDetails;       
                    }                             
                    }
            }
        } 
        //if (this.sharedService.importXMLData != undefined) {
                
        //}
    }*/
    initiateData() {
        //Modified by PP(2023-02-28) : Get from userino. If no data, then projectinfo - START
        // if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
        //     this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
        // } else {
        //     this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
        // }

        if (this.userInfoService.userData != null || this.userInfoService.userData != undefined) {
            if (this.userInfoService.userData.UserUnitId === this.sharedService.unitId_SI) {
                this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
            } else {
                this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
            }
        } else {
            if (this.projectService.projectdetails.projectInfo != null || this.projectService.projectdetails.projectInfo != undefined) {
                if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
                    this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
                } else {
                    this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
                }
            }
        }
        //Modified by PP(2023-02-28) : Get from userino. If no data, then projectinfo - END

        this.UserIsAdmin = this.sharedService.listData.UserCanUseExcel; //Modified by PP(2022-09-21) : Follow CLD 2.0 : CLD 3.0 MVP1.0 - If record found in ownersetting, this user is an admin

        //Remove filter if selected gas not exist
        let solutionDetailneedRemove = [];
        for (let i = 0; i < this.solutions.length; i++) {
            for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                this.solutions[i].solutionDetails[j].displayTypeForMoreInfo = 'More Information';

                //clear selected filter if selected gas changed
                let currentSolution = this.solutions[i].solutionDetails[j];
                for (let x = 0; x < currentSolution.combinationGas.length; x++) {
                    let selectedGas = currentSolution.combinationGas[x];
                    let foundgas = false;
                    for (let y = 0; y < this.availableGas.length; y++) {
                        let tmpAvailableGas = this.availableGas[y];
                        //Modified by PP(2023-06-07) : Allow same gas diff conc value if (tmpAvailableGas.chemicalID===selectedGas.chemicalID) {
                        if (tmpAvailableGas.index === selectedGas.index) { //Modified by PP(2023-06-07) : Allow same gas diff conc value
                            foundgas = true;
                            break;
                        }
                    }
                    if (foundgas === false) {
                        let needRemove = {
                            solution: this.solutions[i],
                            combinationId: currentSolution.combinationID
                        };
                        solutionDetailneedRemove.push(needRemove);
                    }
                }
                //If load data, moreInformation is missing
                // pinky 2nd dec add. to test

                //Dont think i need this as results still here. Loadfromxml straight goes to Results then i click on Solutions
                // if (this.sharedService.importXMLData != undefined) {
                //     let results={};
                //     results = this.projectService.getSolResultsStructure(this.sharedService.importXMLData.Params.MCCLDResults);
                //     this.projectService.projectdetails.results=results;
                // }

                /*this.results = this.projectService.projectdetails.results.solutionsResults;
                if (this.solutions[i].solutionDetails[j].moreInformation == undefined) {
                    if (this.results != undefined) {
                        for (let y=0; y< this.results.length; y++) {
                            if (this.solutions[i].solutionID == this.results[y].solutionID) {
                                for (let z=0; z< this.results[y].results.length; z++) {
                                    if (this.solutions[i].solutionDetails[j].combinationID == this.results[y].results[z].combinationID) {                                   
                                        let newMoreInfoDetails = this.projectService.getMoreInfoForSolutionEmptyvalueStructure();
                                        newMoreInfoDetails.effectiveMediaWeight = this.sharedService.formatValue(parseFloat(this.results[y].results[z].effMediaWeight.toFixed(1)), true);                                       
                                        newMoreInfoDetails.frontVelocity = this.sharedService.formatValue(parseFloat(this.results[y].results[z].frontVelocity.toFixed(2)), true);                                   
                                        newMoreInfoDetails.totalWeight = this.sharedService.formatValue(parseFloat(this.results[y].results[z].totalWeight.toFixed(1)), true);                    
                                        newMoreInfoDetails.contactTime = this.sharedService.formatValue(parseFloat(this.results[y].results[z].contactTime.toFixed(2)), true);
                                        this.solutions[i].solutionDetails[j].moreInformation = newMoreInfoDetails;       
                                    }
                                }                              
                            }                           
                        } 
                    } else {
                        let newMoreInfoDetails = this.projectService.getMoreInfoForSolutionEmptyvalueStructure();
                        newMoreInfoDetails.effectiveMediaWeight = 0;                                       
                        newMoreInfoDetails.frontVelocity = 0;                                   
                        newMoreInfoDetails.totalWeight = 0;                    
                        newMoreInfoDetails.contactTime = 0;
                        this.solutions[i].solutionDetails[j].moreInformation = newMoreInfoDetails;       
                    }                             
                }*/
            }
        }
        for (let i = 0; i < solutionDetailneedRemove.length; i++) {
            let selected = solutionDetailneedRemove[i];
            this.removeFilter(selected.solution, selected.combinationId);
            let index = this.solutions.filter(sol => sol.solutionID == selected.solution.solutionID)[0].solutionDetails.findIndex(itm => itm.combinationID === selected.combinationId);
            if (index > -1) {
                this.solutions.filter(sol => sol.solutionID == selected.solution.solutionID)[0].solutionDetails.splice(index, 1);
                if (this.solutions.filter(sol => sol.solutionID == selected.solution.solutionID)[0].solutionDetails.length === 0) {
                    let iSolution = this.solutions.findIndex(sol => sol.solutionID == selected.solution.solutionID);
                    if (iSolution > -1) {
                        this.addSolDetails(iSolution);
                    }
                }

            }
        }
        //if (this.sharedService.importXMLData != undefined) {

        //}
    }
    //Modified by PS(2023-03-24): MCCLD 2023-Solution page: Fix bug - clear selected filter when gas changed-END
    checkIfMediaCompletesLoading() {
        this.AllDDLList = this.sharedService.listData;

        //Modified by PP(2023-04-07) : To cater for missing medias - START but unable to test because sometimes it happens
        if (this.AllDDLList.AMCMolecularClass == undefined) {
            this.AllDDLList.AMCMolecularClass = this.sharedService.AMCMolecularClass;
        }

        if (this.AllDDLList.ChemicalFilters == undefined) {
            this.AllDDLList.ChemicalFilters = this.sharedService.ChemicalFilters;
        }
        //Modified by PP(2023-04-07) : To cater for missing medias - END

        if (this.ChemicalMediaList === undefined || this.FilterChemicals === undefined) {
            console.log("in checkIfMediaCompletesLoading : first condition");
            this.loadingFilterList = true;
            if (this.AllDDLList.AMCMolecularClass != undefined) {
                this.ChemicalMediaList = [];
                for (let i = 0; i < this.AllDDLList.AMCMolecularClass.length; i++) {
                    let tmpAMCMolClass = {};
                    tmpAMCMolClass = this.AllDDLList.AMCMolecularClass[i];
                    this.ChemicalMediaList.push(tmpAMCMolClass);
                }
                //this.ChemicalMediaList = this.AllDDLList.AMCMolecularClass;
            }
            if (this.AllDDLList.ChemicalFilters != undefined) {
                this.FilterChemicals = [];
                for (let i = 0; i < this.AllDDLList.ChemicalFilters.length; i++) {
                    let tmpChemFilters = {}
                    tmpChemFilters = this.AllDDLList.ChemicalFilters[i];
                    this.FilterChemicals.push(tmpChemFilters);
                }
                //this.FilterChemicals = this.AllDDLList.ChemicalFilters;
            }
        }

        if (this.ChemicalMediaList != undefined && this.FilterChemicals != undefined) {
            console.log("in checkIfMediaCompletesLoading : second condition");
            this.loadingFilterList = false;
            this.toEnableDisableObj(1, 1, 'enable');
            //clearInterval(this.refreshIntervalId);
        }
    }

    addSolution() {
        //var newSolution = {};
        //newSolution = [{"solutionID":1,"solutionName":"Solution 1","solutionDetails":[],"editMode":false}];
        if (this.solutions.length > 2) {
        } else {
            var newSolution = this.projectService.getSolutionsForComparisonEmptyValueStructure();
            var newSolID = this.projectService.projectdetails.solutions.length + 1;
            newSolution.solutionID = newSolID;
            newSolution.solutionName = "Solution " + newSolID;
            this.solutions.push(newSolution);
            this.addSolDetails(this.solutions.length - 1);
        }
    }

    addSolDetails(pIndex) {
        if (this.solutions[pIndex].solutionDetails != undefined) {
            if (this.solutions[pIndex].solutionDetails.length > 2) {
            } else {
                //this.inum = this.solutions.solutionDetails.length + 1;
                var newSolutionDetails = this.projectService.getsolutionDetailsEmptyvalueStructure();
                var newCombinationID = this.solutions[pIndex].solutionDetails.length + 1;
                newSolutionDetails.combinationID = newCombinationID;
                //this.solutions[pIndex].solutionDetails = newSolutionDetails;
                this.solutions[pIndex].solutionDetails.push(newSolutionDetails);
            }
        } else {
            var newSolutionDetails = this.projectService.getsolutionDetailsEmptyvalueStructure();
            this.solutions[pIndex].solutionDetails.push(newSolutionDetails);
        }

        this.filtersStep = 1;

        setTimeout(() => {
            this.makeDefaultCSSForChemicalCheckBoxes(false, this.solutions[pIndex].solutionID, this.solutions[pIndex].solutionDetails.length, false, true);
        }, 10);
    }

    setEnableStageButtons() {
        for (let i = 0; i < this.solutions.length; i++) {
            for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                switch (this.solutions[i].solutionDetails[j].totalStage) {
                    case 1:
                        var eleStage1 = document.getElementById('btnStage1For' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID);
                        var eleStage2 = document.getElementById('btnStage2For' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID);
                        var eleStage3 = document.getElementById('btnStage3For' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID);

                        eleStage1.className = 'selectedStage-btn';
                        eleStage2.className = 'unSelectedStage-btn';
                        eleStage3.className = 'unSelectedStage-btn';
                        break;
                    case 2:
                        var eleStage1 = document.getElementById('btnStage1For' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID);
                        var eleStage2 = document.getElementById('btnStage2For' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID);
                        var eleStage3 = document.getElementById('btnStage3For' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID);

                        eleStage1.className = 'unSelectedStage-btn';
                        eleStage2.className = 'selectedStage-btn';
                        eleStage3.className = 'unSelectedStage-btn';
                        break;
                    case 3:
                        var eleStage1 = document.getElementById('btnStage1For' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID);
                        var eleStage2 = document.getElementById('btnStage2For' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID);
                        var eleStage3 = document.getElementById('btnStage3For' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID);

                        eleStage1.className = 'unSelectedStage-btn';
                        eleStage2.className = 'unSelectedStage-btn';
                        eleStage3.className = 'selectedStage-btn';
                        break;
                }
            }
        }
    }

    makeDefaultCSSForChemicalCheckBoxes(NeedToLoopAllSolutions: boolean, pSolID: number, pSolDetID: number, FromAddMedia: boolean, FromAddSolDetails: boolean) {
        //For Other Gasses -> onCheckBoxChange()

        //For Normal Gasses
        if (NeedToLoopAllSolutions) { //From ngAfterViewInit : To cater for new project, load or change page - need to loop solutions
            this.CSSForChemicalCheckBoxesForAllSolutions();
        } else {
            if (FromAddMedia) { //Current Combination ID
                for (let i = 0; i < this.solutions.length; i++) {
                    if (this.solutions[i].solutionID == pSolID) {
                        //Loop from available gas and make all black and disabled
                        for (let k = 0; k < this.availableGas.length; k++) {
                            // Disable checkbox
                            var gasCheckBox: any;
                            gasCheckBox = document.getElementById('chkGas' + pSolID + pSolDetID + k);
                            if (gasCheckBox != null || gasCheckBox != undefined) {
                                gasCheckBox.disabled = true;
                                gasCheckBox.checked = false;
                            }

                            // Black for checkbox
                            var gasDiv: any;
                            gasDiv = document.getElementById('divGas' + pSolID + pSolDetID + k);
                            if (gasDiv != null || gasDiv != undefined) {
                                gasDiv.className = 'blackFontForCheckBox';
                            }
                        }

                        //Loop from available gas and loop combination gas. If found then green and enabled
                        for (let k = 0; k < this.availableGas.length; k++) {
                            for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                                if (this.solutions[i].solutionDetails[j].combinationID == pSolDetID) {
                                    for (let l = 0; l < this.solutions[pSolID - 1].solutionDetails[j].combinationGas.length; l++) {
                                        //Modified by PP(2023-06-07) : Allow same gas diff conc value if (this.availableGas[k].chemicalID == this.solutions[pSolID-1].solutionDetails[j].combinationGas[l].chemicalID) {
                                        if (this.availableGas[k].index == this.solutions[pSolID - 1].solutionDetails[j].combinationGas[l].index) { //Modified by PP(2023-06-07) : Allow same gas diff conc value
                                            // Enable all checkboxes
                                            var gasCheckBox: any;
                                            gasCheckBox = document.getElementById('chkGas' + pSolID + pSolDetID + k);
                                            if (gasCheckBox != null || gasCheckBox != undefined) {
                                                gasCheckBox.disabled = false;
                                                gasCheckBox.checked = true;
                                            }

                                            // Green
                                            var gasDiv: any;
                                            gasDiv = document.getElementById('divGas' + pSolID + pSolDetID + k);
                                            if (gasDiv != null || gasDiv != undefined) {
                                                gasDiv.className = 'greenFontForCheckBox';
                                            }

                                            // If only one gas available then default make it checked
                                            if (this.availableGas.length === 1) {
                                                if (gasCheckBox != null || gasCheckBox != undefined) {
                                                    gasCheckBox.checked = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        // Loop available gas and loop previous combination (<> pSolDetID). If found then check it
                        for (let k = 0; k < this.availableGas.length; k++) {
                            for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                                if (this.solutions[i].solutionDetails[j].combinationID != pSolDetID) {
                                    for (let l = 0; l < this.solutions[pSolID - 1].solutionDetails[j].combinationGas.length; l++) {
                                        //Modified by PP(2023-06-07) : Allow same gas diff conc value if (this.availableGas[k].chemicalID == this.solutions[pSolID-1].solutionDetails[j].combinationGas[l].chemicalID) {
                                        if (this.availableGas[k].index == this.solutions[pSolID - 1].solutionDetails[j].combinationGas[l].index) { //Modified by PP(2023-06-07) : Allow same gas diff conc value
                                            //Checked the black checkboxes
                                            var gasCheckBox: any;
                                            gasCheckBox = document.getElementById('chkGas' + pSolID + pSolDetID + k);
                                            if (gasCheckBox != null || gasCheckBox != undefined) {
                                                gasCheckBox.disabled = true;
                                                gasCheckBox.checked = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }


            }

            if (FromAddSolDetails) { //solutiondetails.length -1
                //Make all green for new combination
                for (let k = 0; k < this.availableGas.length; k++) {
                    var LastSolDetIndex = this.solutions[pSolID - 1].solutionDetails.length;

                    // Enable all checkboxes
                    var gasCheckBox: any;
                    gasCheckBox = document.getElementById('chkGas' + pSolID + LastSolDetIndex + k);
                    if (gasCheckBox != null || gasCheckBox != undefined) {
                        gasCheckBox.disabled = false;
                    }

                    // Green for all checkboxes
                    var gasDiv: any;
                    gasDiv = document.getElementById('divGas' + pSolID + LastSolDetIndex + k);
                    if (gasDiv != null || gasDiv != undefined) {
                        gasDiv.className = 'greenFontForCheckBox';
                    }

                    // If only one gas available then default make it checked
                    if (this.availableGas.length === 1) {
                        if (gasCheckBox != null || gasCheckBox != undefined) {
                            gasCheckBox.checked = true;
                        }
                    }
                }

                //Loop previous combination and disabled, checked and blacked if found
                for (let i = 0; i < this.solutions.length; i++) {
                    if (this.solutions[i].solutionID == pSolID) {
                        var LastSolDetIndex = this.solutions[pSolID - 1].solutionDetails.length;

                        for (let k = 0; k < this.availableGas.length; k++) {
                            for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                                if (this.solutions[i].solutionDetails[j].combinationID != LastSolDetIndex) {
                                    for (let l = 0; l < this.solutions[pSolID - 1].solutionDetails[j].combinationGas.length; l++) {
                                        //Modified by PP(2023-06-07) : Allow same gas diff conc value if (this.availableGas[k].chemicalID == this.solutions[pSolID-1].solutionDetails[j].combinationGas[l].chemicalID) {
                                        if (this.availableGas[k].index == this.solutions[pSolID - 1].solutionDetails[j].combinationGas[l].index) { //Modified by PP(2023-06-07) : Allow same gas diff conc value
                                            // Disable checkbox
                                            var gasCheckBox: any;
                                            gasCheckBox = document.getElementById('chkGas' + pSolID + LastSolDetIndex + k);
                                            if (gasCheckBox != null || gasCheckBox != undefined) {
                                                gasCheckBox.disabled = true;
                                                gasCheckBox.checked = true;
                                            }

                                            // Black for checkbox
                                            var gasDiv: any;
                                            gasDiv = document.getElementById('divGas' + pSolID + LastSolDetIndex + k);
                                            if (gasDiv != null || gasDiv != undefined) {
                                                gasDiv.className = 'blackFontForCheckBox';
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

    }

    CSSForChemicalCheckBoxesForAllSolutions() {
        for (let i = 0; i < this.solutions.length; i++) {
            for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                if (this.solutions[i].solutionDetails[j].combinationGas.length == 0) {
                    for (let k = 0; k < this.availableGas.length; k++) {
                        // Enable all checkboxes
                        var gasCheckBox: any;
                        gasCheckBox = document.getElementById('chkGas' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID + k);
                        if (gasCheckBox != null || gasCheckBox != undefined) {
                            gasCheckBox.disabled = false;
                        }

                        // Green for all checkboxes
                        var gasDiv: any;
                        gasDiv = document.getElementById('divGas' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID + k);
                        if (gasDiv != null || gasDiv != undefined) {
                            gasDiv.className = 'greenFontForCheckBox';
                        }

                        // If only one gas available then default make it checked
                        if (this.availableGas.length === 1) {
                            if (gasCheckBox != null || gasCheckBox != undefined) {
                                gasCheckBox.checked = true;
                            }
                        }
                    }
                } else {
                    //Disable all check boxes first
                    for (let m = 0; m < this.availableGas.length; m++) {
                        // Black for checkbox
                        var gasDiv: any;
                        gasDiv = document.getElementById('divGas' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID + m);
                        if (gasDiv != null || gasDiv != undefined) {
                            gasDiv.className = 'blackFontForCheckBox';
                        }

                        // Disable checkbox
                        var gasCheckBox: any;
                        gasCheckBox = document.getElementById('chkGas' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID + m);
                        if (gasCheckBox != null || gasCheckBox != undefined) {
                            gasCheckBox.disabled = true;
                            gasCheckBox.checked = false;// true; //Modified by PS(2023-03-27): MCCLD 2023-Solution page: Fix bugs-START
                            //why false? when jump back to solutions page from results, it becomes unchecked but disabled is correct gasCheckBox.checked = false;
                        }
                    }

                    //Enable checkboxes
                    for (let l = 0; l < this.solutions[i].solutionDetails[j].combinationGas.length; l++) {
                        var indexForAvailableGas = 99;
                        var foundForThisGas = false;
                        for (let m = 0; m < this.availableGas.length; m++) {
                            //Modified by PP(2023-06-07) : Allow same gas diff conc value if (this.solutions[i].solutionDetails[j].combinationGas[l].chemicalID == this.availableGas[m].chemicalID) {
                            if (this.solutions[i].solutionDetails[j].combinationGas[l].index == this.availableGas[m].index) { //Modified by PP(2023-06-07) : Allow same gas diff conc value
                                foundForThisGas = true;
                                indexForAvailableGas = m;
                                break;
                            }
                        }
                        if (foundForThisGas) { //Green & Enable
                            // Green for checkbox
                            var gasDiv: any;
                            gasDiv = document.getElementById('divGas' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID + indexForAvailableGas);
                            if (gasDiv != null || gasDiv != undefined) {
                                gasDiv.className = 'greenFontForCheckBox';
                            }

                            // Enable checkbox
                            var gasCheckBox: any;
                            gasCheckBox = document.getElementById('chkGas' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID + indexForAvailableGas);
                            if (gasCheckBox != null || gasCheckBox != undefined) {
                                gasCheckBox.disabled = false;
                                gasCheckBox.checked = true;
                            }
                        } else { //Black & Disable
                            // Black for checkbox
                            var gasDiv: any;
                            gasDiv = document.getElementById('divGas' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID + indexForAvailableGas);
                            if (gasDiv != null || gasDiv != undefined) {
                                gasDiv.className = 'blackFontForCheckBox';
                            }

                            // Disable checkbox
                            var gasCheckBox: any;
                            gasCheckBox = document.getElementById('chkGas' + this.solutions[i].solutionID + this.solutions[i].solutionDetails[j].combinationID + indexForAvailableGas);
                            if (gasCheckBox != null || gasCheckBox != undefined) {
                                gasCheckBox.disabled = true;
                                gasCheckBox.checked = true;
                                //why false? when jump back to solutions page from results, it becomes unchecked but disabled is correct gasCheckBox.checked = false;
                            }
                        }
                    }
                }
            }
        }
    }

    testCode(soldet: any, pIndex: any) {
        var abc = 123;
    }

    tabkeyChanges(e: MouseEvent, i: number) {
        this.onMouseClick(e);
    }

    onMouseClick(e: MouseEvent) {

    }

    showHideInfoToggle(event) {
        let SolutionInfo = document.getElementById('divSolutionInfo');
        let StagesInfo = document.getElementById('divStagesInfo');
        let AddSolutionInfo = document.getElementById('divAddSolutionInfo');

        if (!this.SolutionInfo && event === 'SolutionInfo') {
            SolutionInfo.setAttribute('data-show', '');
            this.SolutionInfo = true;
        } else if (this.SolutionInfo && event === 'SolutionInfo') {
            SolutionInfo.removeAttribute('data-show');
            this.SolutionInfo = false;
        }

        if (!this.StagesInfo && event === 'StagesInfo') {
            StagesInfo.setAttribute('data-show', '');
            this.StagesInfo = true;
        } else if (this.StagesInfo && event === 'StagesInfo') {
            StagesInfo.removeAttribute('data-show');
            this.StagesInfo = false;
        }

        if (!this.AddSolutionInfo && event === 'AddSolutionInfo') {
            AddSolutionInfo.setAttribute('data-show', '');
            this.AddSolutionInfo = true;
        } else if (this.AddSolutionInfo && event === 'AddSolutionInfo') {
            AddSolutionInfo.removeAttribute('data-show');
            this.AddSolutionInfo = false;
        }

        //AddSolutionInfo

    }

    setPoppers() {
        let SolutionInfoBtn = document.querySelector('#SolutionInfoBtn');
        let SolutionInfo = document.getElementById('divSolutionInfo');

        let StagesInfoBtn = document.querySelector('#StagesInfoBtn');
        let StagesInfo = document.getElementById('divStagesInfo');

        let AddSolutionInfoBtn = document.querySelector('#AddSolutionInfoBtn');
        let AddSolutionInfo = document.getElementById('divAddSolutionInfo');

        this.createPop(SolutionInfoBtn, SolutionInfo);
        this.createPop(StagesInfoBtn, StagesInfo);
        this.createPop(AddSolutionInfoBtn, AddSolutionInfo);
    }

    createPop(ref: any, popper: any) {
        createPopper(ref, popper, {
            placement: 'top-start',
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 8],
                    },
                },
            ],
        });
    }

    validateSpecialChar(event: any) {
        var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
        if (format.test(event.key)) {
            this.toastr.warning('Invalid character - you may not use certain characters here', '');
            return false;
        } else {
            return true;
        }
    }

    toggleEditMode(solution) {
        if (!solution.editMode) {
            this.solutions.filter(sol => sol.solutionID == solution.solutionID)[0].editMode = true;
        }
        else {
            this.solutions.filter(sol => sol.solutionID == solution.solutionID)[0].editMode = false;
        }
    }

    detectChanges(evt: any, index: number, controlname: string) {

    }

    deleteSol(pSolution: any) {
        let ConfirmHead = "Confirmation";
        let Confirmbody = "Do you really want to delete the '" + pSolution.solutionName + "' solution?";

        let ConfirmBtn = "Yes - Delete";
        let CancelBtn = "No - Cancel";

        this.confirmationDialogService.confirm(ConfirmHead, Confirmbody, ConfirmBtn, CancelBtn)
            .then((confirmed) => {
                this.solutions.splice(this.solutions.findIndex(item => {
                    return item.solutionID == pSolution.solutionID;
                }), 1);

                //Reindex Solutions
                for (var p = 0; p < this.projectService.projectdetails.solutions.length; p++) {
                    let oldSolName = 'Solution ' + this.projectService.projectdetails.solutions[p].solutionID;
                    this.projectService.projectdetails.solutions[p].solutionID = p + 1;
                    let newSolName = 'Solution ' + this.projectService.projectdetails.solutions[p].solutionID;

                    if (this.projectService.projectdetails.solutions[p].solutionName === oldSolName) {
                        this.projectService.projectdetails.solutions[p].solutionName = newSolName;
                    }
                }

                //this.setAllSolutions();
                //this.clearReport(solution.id);
                //this.removeCompareSolution(solution.id); 
            })
            .catch(() => console.log('User dismissed the dialog'));
    }

    next() {
        this.nextStep.emit();
    }

    Proceed() {
        //this.next();

        let validation = this.projectService.checkValidation(4);
        validation = false;
        if (validation === false) {
            this.projectService.activePage = 4;
            this.toastr.warning('Calculation is still in progress. Please try again.', '');

        } else {
            this.projectService.valid.solutions = 'Valid';
            this.nextStep.emit();
            //this.projectService.activePage = 4;
        }
    }

    onCheckBoxChange(pEvent: any, pSolutionID, pCombinationID) {
        if (pEvent.currentTarget.checked) { //Check
            //If single gas, disabled other gas Combination
            //Modified by PP(2023-02-09) : To cater for not getting multi gas alrogrithm if (pEvent.currentTarget.name.includes('Others')) {
            if (pEvent.currentTarget.name.includes('Others') || this.sharedService.EnableMultiGasCalculation === false) { //Modified by PP(2023-02-09) : To cater for not getting multi gas alrogrithm
                for (let i = 0; i < this.availableGas.length; i++) {
                    var gasCheckBox: any;
                    gasCheckBox = document.getElementById('chkGas' + pSolutionID + pCombinationID + i);
                    if (gasCheckBox.id === pEvent.currentTarget.id) {
                        var gasDiv: any;
                        gasDiv = document.getElementById('divGas' + pSolutionID + pCombinationID + i);
                        gasDiv.className = 'greenFontForCheckBox';
                    } else {
                        gasCheckBox.disabled = true;

                        var gasDiv: any;
                        gasDiv = document.getElementById('divGas' + pSolutionID + pCombinationID + i);
                        gasDiv.className = 'blackFontForCheckBox';
                    }
                }
            }
        } else { //Uncheck
            for (let i = 0; i < this.solutions.length; i++) {
                if (this.solutions[i].solutionID == pSolutionID) {
                    for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                        if (this.solutions[i].solutionDetails[j].combinationID === pCombinationID) {
                            this.solutions[i].solutionDetails.splice(j, 1);
                            this.checkIfStillAbleToAddSolDets(pSolutionID);
                        }
                    }
                }
            }
        }
    }

    openFilterSelectionPopUp(content, pSolution, pSolDet, WhichSolution, WhichCombination) {
        if (this.FilterChemicals == undefined || this.FilterChemicals == null) {
            this.checkIfMediaCompletesLoading();
        }

        var isOthers = false;
        this.element = pSolution;
        this.Stage = pSolDet.combinationID;

        if (pSolDet.inputSize === 0 && this.filtersStep === 2) {
            this.filtersStep = 1;
        }

        if (pSolDet.molecularID > 0 && pSolDet.inputSize == 1) {
            this.filtersStep = 2;

            this.showMolecularTypeInCustomSizePage = pSolDet.molecularType;
            this.showMolecularDisplayNameInCustomSizePage = pSolDet.filterName;
            this.showMolecularNameInCustomSizePage = pSolDet.filterName;
        }

        //Modified by PP(2023-06-15) : Cancel and [X] not working for Custom Media Size - START
        this.customMediaSizeForInput = this.projectService.getCustomMediaSizeEmptyvalueStructure();
        if (pSolDet.inputSize === 1) {
            this.getCustomSizeFromSolDet(pSolDet.customMediaSize);

            //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174 - START
            switch (pSolDet.customMediaSize.shapeType) {
                case 1:
                    this.selectedShape =  "rectangle";
                    break;

                case 2:
                    this.selectedShape =  "cylinder";
                    break;
            }            
            //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174 - END
            
            //this.customMediaSizeForInput = this.projectService.getCustomMediaSizeEmptyvalueStructure();       
        } else {
            this.selectedShape =  "rectangle"; //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
        }
        //Modified by PP(2023-06-15) : Cancel and [X] not working for Custom Media Size - END

        //Get checked gas selection       
        this.getGasCheck(WhichSolution, WhichCombination);

        if (this.gasChecked.length == 0) {
            this.toastr.warning('Please select at least one contamination', '');
        } else {
            //Find correct Medias for Chemical checked
            var foundMedia = false;
            for (let j = 0; j < this.gasChecked.length; j++) {
                if (this.gasChecked[j].gasName.includes('Others')) {
                    isOthers = true;
                }
                for (let k = 0; k < this.FilterChemicals.length; k++) {
                    if (this.FilterChemicals[k].ChemicalID == this.gasChecked[j].gasID) {
                        this.filterGrp = this.FilterChemicals[k].Groups;
                        foundMedia = true;
                        break;
                    }
                }
                if (foundMedia) {
                    break;
                } else { //No Media Found
                    if (isOthers) {
                        // for (let a=0 ; a< this.availableGas.length; a++) {
                        //     var gasCheckBox:any;        
                        //     gasCheckBox = document.getElementById('chkGas' + WhichSolution + WhichCombination + a);
                        //     gasCheckBox.disabled = false;
                        //     gasCheckBox.checked = false;

                        //     var gasDiv:any;
                        //     gasDiv = document.getElementById('divGas' + WhichSolution + WhichCombination + a);
                        //     gasDiv.className = 'greenFontForCheckBox';
                        // }
                        this.filterGrp = this.sharedService.chemfilterfromserver.FilterChemicals;
                        foundMedia = true;
                    } else {
                        this.toastr.warning('No Media Found', '');
                    }
                }
            }

            if (foundMedia) {
                this.modalService.open(content, {
                    ariaLabelledBy: 'modal-basic-title',
                    centered: true,
                    backdrop: 'static'
                }).result.then((result) => {
                    this.closeResult = `Closed with: ${result}`;
                }, (reason) => {
                    this.closeResult = `Dismissed`;
                });
            }
            // this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',
            //     centered: true,
            //     backdrop: 'static'}).result.then((result) => {               
            //     this.closeResult = `Closed with: ${result}`;
            // }, (reason) => {            
            //     this.closeResult = `Dismissed`;
            // }); 
        }
    }

    getGasCheck(pSolID, pCombinationID) {
        this.gasChecked = [];

        for (let i = 0; i < this.availableGas.length; i++) {
            var gasCheckBox: any;
            gasCheckBox = document.getElementById('chkGas' + pSolID + pCombinationID + i);
            if (gasCheckBox.checked == true && gasCheckBox.disabled == false) {
                //Modified by PP(2023-06-07) : Allow same gas diff conc value - START
                // let tmp = {
                //     index: parseInt(gasCheckBox.value),
                //     gasID: this.availableGas[i].chemicalID,
                //     gasName: gasCheckBox.name
                // }
                // this.gasChecked.push(tmp);
                if (this.availableGas[i].index === parseInt(gasCheckBox.value)) {
                    let tmp = {
                        index: parseInt(gasCheckBox.value),
                        gasID: this.availableGas[i].chemicalID,
                        gasName: gasCheckBox.name
                    }
                    this.gasChecked.push(tmp);
                }
                //Modified by PP(2023-06-07) : Allow same gas diff conc value - END          
            }
        }
    }

    cleanMedia() {
        this.selSearchFilterBtn = 2;
        this.selFilter = '';
        this.filtersStep = 1;
        //this.totalCost = null;
    }

    back() {
        this.selFilter = '';
        this.filtersStep = 1;
    }

    search(data) {
        var SearchValue = "";
        switch (this.sharedService.userBrowser) { // Refer to shared.service.ts detectUserBrowser()
            case "chrome":
                //SearchValue = data.path[0].value;
                SearchValue = data.currentTarget.value;
                break;

            case "firefox":
                SearchValue = data.currentTarget.value;
                break;

            case "edge":
                SearchValue = data.target.value;
                break;

            // case "opera":

            // break;

            // case "ie":

            // break;

            // case "safari":

            // break;

            default:
                SearchValue = data.path[0].value;
                break;
        }

        SearchValue = SearchValue.toLowerCase();
        switch (this.selSearchFilterBtn) {
            case 1:
                this.Filters = this.allFilters.filter(x => {

                });
                break;
            case 2:
                break;
        }
    }

    selSearchFilter(data) {
        this.selSearchFilterBtn = data;
        //this.calresultMsg = '';
        //this.calresultError ;

        if (data === 2) {
            this.searchMode = "Group";
            this.filterGrp = this.allFilterGrp;
        }
    }

    selectFilter(filter, types, solution, pStage) {

        this.loading = true;
        this.currentsolution = solution;

        if (filter != null) {
            this.selFilter = filter;
        }

        if (types != null) {
            this.selTypes = types;
        }

        //var showCustomSizePage = false;
        var toContinue = false;

        //Check if Custom Media Size is needed
        if (this.selTypes === undefined || this.selTypes === null) {
            for (let i = 0; i < this.filterGrp.length; i++) {
                if (this.filterGrp[i].MolecularGroupID === solution.solutionDetails[0].molecularGroupID) {
                    for (let j = 0; j < this.filterGrp[i].Types.length; j++) {
                        if (this.filterGrp[i].Types[j].MolecularTypeID === solution.solutionDetails[0].molecularTypeID) {
                            this.selTypes = this.filterGrp[i].Types[j];
                            for (let k = 0; k < this.filterGrp[i].Types[j].Moleculars.length; k++) {
                                if (this.filterGrp[i].Types[j].Moleculars[k].MolecularID === solution.solutionDetails[0].molecularID) {
                                    this.selFilter = this.filterGrp[i].Types[j].Moleculars[k];
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }

        if (this.selTypes.InputSize === 1) {
            for (let i = 0; i < this.solutions.length; i++) {
                if (this.solutions[i].solutionID == solution.solutionID) {
                    if (this.solutions[i].solutionDetails.length > 0) {
                        for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                            if (this.solutions[i].solutionDetails[j].combinationID == pStage) {
                                //If inputsize=1 but different media than previously selected
                                if (filter != null) {
                                    if (this.solutions[i].solutionDetails[j].molecularID != filter.MolecularID) {
                                        this.solutions[i].solutionDetails[j].customMediaSize.depth = 0;
                                        this.solutions[i].solutionDetails[j].customMediaSize.height = 0;
                                        this.solutions[i].solutionDetails[j].customMediaSize.length = 0;
                                        this.solutions[i].solutionDetails[j].customMediaSize.diameter = 0; //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
                                        this.solutions[i].solutionDetails[j].customMediaSize.shapetype = 1;//Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
                                    }
                                } else { //<Modified by PP(2023-05-25) : User can key in zero in custom sizes
                                    this.getCustomSizeFromTmpArray(this.solutions[i].solutionDetails[j].customMediaSize); //Modified by PP(2023-06-15) : Cancel and [X] not working for Custom Media Size
                                }

                                //If Solution Media Size is blank then show
                                if (this.solutions[i].solutionDetails[j].customMediaSize.depth == 0 && this.solutions[i].solutionDetails[j].customMediaSize.height == 0 && this.solutions[i].solutionDetails[j].customMediaSize.length == 0) {
                                    if (filter != null) {
                                        this.showMolecularTypeInCustomSizePage = filter.MolecularType;
                                        this.showMolecularDisplayNameInCustomSizePage = filter.MolecularDisplayName;
                                        this.showMolecularNameInCustomSizePage = filter.MolecularName;
                                        this.filtersStep = 2;
                                        toContinue = false; //To show Custom Media size screen
                                    } else {
                                        this.filtersStep = 2;
                                        toContinue = true;
                                    }
                                    //this.filtersStep = 2;
                                } else {
                                    this.filtersStep = 2;
                                    toContinue = true;
                                }

                                this.getCustomSizeFromSolDet(this.solutions[i].solutionDetails[j].customMediaSize); //Modified by PP(2023-06-15) : Cancel and [X] not working for Custom Media Size
                            }
                        }
                    }
                }
            }
        } else { //Normal Media Selected
            // Remove Existing Custom Media Info if previous selected is inputsize=1
            for (let i = 0; i < this.solutions.length; i++) {
                if (this.solutions[i].solutionID == solution.solutionID) {
                    if (this.solutions[i].solutionDetails.length > 0) {
                        for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                            if (this.solutions[i].solutionDetails[j].combinationID == pStage) {
                                this.solutions[i].solutionDetails[j].customMediaSize.depth = 0;
                                this.solutions[i].solutionDetails[j].customMediaSize.height = 0;
                                this.solutions[i].solutionDetails[j].customMediaSize.length = 0;
                                this.solutions[i].solutionDetails[j].customMediaSize.diameter = 0; //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
                                this.solutions[i].solutionDetails[j].customMediaSize.shapetype = 1;//Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
                            }
                        }
                    }
                }
            }

            this.filtersStep = 1;
            toContinue = true;
        }

        if (toContinue) {
            //If SingleStage then disabled Stage 2 & 3       
            if (this.selTypes.SingleStage == 1) {
                var stg2btn = (<HTMLInputElement>document.getElementById('btnStage2For' + solution.solutionID + pStage));
                stg2btn.disabled = true;

                var stg3btn = (<HTMLInputElement>document.getElementById('btnStage3For' + solution.solutionID + pStage));
                stg3btn.disabled = true;
            } else {
                var stg2btn = (<HTMLInputElement>document.getElementById('btnStage2For' + solution.solutionID + pStage));
                stg2btn.disabled = false;

                var stg3btn = (<HTMLInputElement>document.getElementById('btnStage3For' + solution.solutionID + pStage));
                stg3btn.disabled = false;
            }

            //Get checked gas selection       
            this.getGasCheck(solution.solutionID, pStage);

            let newSelectedMedia = {
                "molecular": this.selFilter.MolecularName,
                "molecularDisplayName": this.selFilter.MolecularDisplayName,
                "molecularID": this.selFilter.MolecularID,
                "molecularPic": this.selFilter.MolecularPic,
                "molecularGroupID": this.selFilter.MolecularGroupID,
                "molecularGroup": this.selFilter.MolecularGroup,
                "molecularTypeID": this.selFilter.MolecularTypeID,
                "molecularType": this.selFilter.MolecularType,
                "molecularTypePic": this.selFilter.MolecularTypePic,
                "molecularTypeMolecularID": this.selFilter.MolecularTypeMolecularID
            }

            //If Solution Details exist then update, else Insert
            let soldetIndex = 0;
            let found = false;
            for (let i = 0; i < this.solutions.length; i++) {
                if (this.solutions[i].solutionID == solution.solutionID) {
                    if (this.solutions[i].solutionDetails.length > 0) {
                        for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                            if (this.solutions[i].solutionDetails[j].combinationID == pStage) {
                                soldetIndex = j;
                                found = true;

                                //Update
                                this.solutions[i].solutionDetails[j].filterName = newSelectedMedia.molecularDisplayName;
                                this.solutions[i].solutionDetails[j].filterDBName = newSelectedMedia.molecular;
                                this.solutions[i].solutionDetails[j].molecularGroup = newSelectedMedia.molecularGroup;
                                this.solutions[i].solutionDetails[j].molecularGroupID = newSelectedMedia.molecularGroupID;
                                this.solutions[i].solutionDetails[j].molecularID = newSelectedMedia.molecularID;
                                this.solutions[i].solutionDetails[j].molecularPic = newSelectedMedia.molecularPic;
                                this.solutions[i].solutionDetails[j].molecularType = newSelectedMedia.molecularType;
                                this.solutions[i].solutionDetails[j].molecularTypeID = newSelectedMedia.molecularTypeID;
                                this.solutions[i].solutionDetails[j].molecularTypePic = newSelectedMedia.molecularTypePic;
                                this.solutions[i].solutionDetails[j].molecularTypeMolecularID = newSelectedMedia.molecularTypeMolecularID;

                                if (this.selTypes.SingleStage == 1) {
                                    this.solutions[i].solutionDetails[j].totalStage = 1;
                                }

                                this.solutions[i].solutionDetails[j].inputSize = this.selTypes.InputSize;

                                if (this.solutions[i].solutionDetails[j].combinationGas.length > 0) {
                                    //Delete existing combinationGas array
                                    for (let k = 0; k < this.solutions[i].solutionDetails[j].combinationGas.length; k++) {
                                        this.solutions[i].solutionDetails[j].combinationGas.splice(k, 1);
                                        k = k - 1;
                                    }
                                }

                                //Modified by PP(2023-06-07) : Allow same gas diff conc value - START
                                // for (let k=0 ; k< this.gasChecked.length; k++) {
                                //     var newCombinationGas = this.projectService.getCombinationGasEmptyvalueStructure();
                                //     newCombinationGas.chemicalID = this.gasChecked[k].gasID;
                                //     newCombinationGas.contaminationType = this.gasChecked[k].gasName;
                                //      this.solutions[i].solutionDetails[j].combinationGas.push(newCombinationGas); 
                                // }
                                for (let k = 0; k < this.gasChecked.length; k++) {
                                    for (let l = 0; l < this.availableGas.length; l++) {
                                        if (this.gasChecked[k].index === this.availableGas[l].index) {
                                            var newCombinationGas = this.projectService.getCombinationGasEmptyvalueStructure();
                                            newCombinationGas.index = this.gasChecked[k].index;
                                            newCombinationGas.chemicalID = this.gasChecked[k].gasID;
                                            newCombinationGas.contaminationType = this.gasChecked[k].gasName;
                                            newCombinationGas.concentrationValue = this.availableGas[l].concentrationValue;
                                            this.solutions[i].solutionDetails[j].combinationGas.push(newCombinationGas);
                                        }
                                    }
                                }
                                //Modified by PP(2023-06-07) : Allow same gas diff conc value - END
                            }
                        }
                    } else {
                        //Insert
                    }

                    //Insert
                    if (!found) {
                        this.addSolDetails(i);
                        for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                            if (this.solutions[i].solutionDetails[j].combinationID == pStage) {
                                soldetIndex = j;
                                found = true;

                                //Update
                                this.solutions[i].solutionDetails[j].filterName = newSelectedMedia.molecularDisplayName;
                                this.solutions[i].solutionDetails[j].filterDBName = newSelectedMedia.molecular;
                                this.solutions[i].solutionDetails[j].molecularGroup = newSelectedMedia.molecularGroup;
                                this.solutions[i].solutionDetails[j].molecularGroupID = newSelectedMedia.molecularGroupID;
                                this.solutions[i].solutionDetails[j].molecularID = newSelectedMedia.molecularID;
                                this.solutions[i].solutionDetails[j].molecularPic = newSelectedMedia.molecularPic;
                                this.solutions[i].solutionDetails[j].molecularType = newSelectedMedia.molecularType;
                                this.solutions[i].solutionDetails[j].molecularTypeID = newSelectedMedia.molecularTypeID;
                                this.solutions[i].solutionDetails[j].molecularTypePic = newSelectedMedia.molecularTypePic;
                                this.solutions[i].solutionDetails[j].molecularTypeMolecularID = newSelectedMedia.molecularTypeMolecularID;

                                if (types.SingleStage == 1) {
                                    this.solutions[i].solutionDetails[j].totalStage = 1;
                                }

                                this.solutions[i].solutionDetails[j].inputSize = this.selTypes.InputSize;

                                if (this.solutions[i].solutionDetails[j].combinationGas.length > 0) {
                                    //Delete existing combinationGas array
                                    for (let k = 0; k < this.solutions[i].solutionDetails[j].combinationGas.length; k++) {
                                        this.solutions[i].solutionDetails[j].combinationGas.splice(k, 1);
                                    }
                                }

                                //Modified by PP(2023-06-07) : Allow same gas diff conc value - START
                                // for (let k=0 ; k< this.gasChecked.length; k++) {
                                //     var newCombinationGas = this.projectService.getCombinationGasEmptyvalueStructure();
                                //     newCombinationGas.chemicalID = this.gasChecked[k].gasID;
                                //     newCombinationGas.contaminationType = this.gasChecked[k].gasName;
                                //     this.solutions[i].solutionDetails[j].combinationGas.push(newCombinationGas); 
                                // }
                                for (let k = 0; k < this.gasChecked.length; k++) {
                                    for (let l = 0; l < this.availableGas.length; l++) {
                                        if (this.gasChecked[k].index === this.availableGas[l].index) {
                                            var newCombinationGas = this.projectService.getCombinationGasEmptyvalueStructure();
                                            newCombinationGas.index = this.gasChecked[k].index;
                                            newCombinationGas.chemicalID = this.gasChecked[k].gasID;
                                            newCombinationGas.contaminationType = this.gasChecked[k].gasName;
                                            newCombinationGas.concentrationValue = this.availableGas[l].concentrationValue;
                                            this.solutions[i].solutionDetails[j].combinationGas.push(newCombinationGas);
                                        }
                                    }
                                }
                                //Modified by PP(2023-06-07) : Allow same gas diff conc value - END
                            }
                        }
                    } else {
                        this.makeDefaultCSSForChemicalCheckBoxes(false, solution.solutionID, pStage, true, false);
                    }
                }
            }
            this.modalService.dismissAll();

            this.toEnableDisableObj(solution.solutionID, pStage, 'disable');

            this.filtersStep = 1; //Modified by PP(2023-06-15) : Cancel and [X] not working for Custom Media Size

            //Trigger Calculation
            this.triggerCalculation(solution.solutionID, pStage, true); //if from nooffilter then false
        }

    }

    removeFilter(pSolution, pCombinationID) {
        //this.solutions.filter(sol=>sol.id==pSolution.solutionID)[0].stageDetails.filter(itm=>itm.stage===item.stage)[0].priceCalculated=false;
        this.solutions.filter(sol => sol.solutionID == pSolution.solutionID)[0].solutionDetails.filter(itm => itm.combinationID === pCombinationID)[0].filterDBName = '';
        this.solutions.filter(sol => sol.solutionID == pSolution.solutionID)[0].solutionDetails.filter(itm => itm.combinationID === pCombinationID)[0].filterName = '';
        this.solutions.filter(sol => sol.solutionID == pSolution.solutionID)[0].solutionDetails.filter(itm => itm.combinationID === pCombinationID)[0].molecularGroup = '';
        this.solutions.filter(sol => sol.solutionID == pSolution.solutionID)[0].solutionDetails.filter(itm => itm.combinationID === pCombinationID)[0].molecularGroupID = '';
        this.solutions.filter(sol => sol.solutionID == pSolution.solutionID)[0].solutionDetails.filter(itm => itm.combinationID === pCombinationID)[0].molecularID = '';
        this.solutions.filter(sol => sol.solutionID == pSolution.solutionID)[0].solutionDetails.filter(itm => itm.combinationID === pCombinationID)[0].molecularPic = '';
        this.solutions.filter(sol => sol.solutionID == pSolution.solutionID)[0].solutionDetails.filter(itm => itm.combinationID === pCombinationID)[0].molecularType = '';
        this.solutions.filter(sol => sol.solutionID == pSolution.solutionID)[0].solutionDetails.filter(itm => itm.combinationID === pCombinationID)[0].molecularTypeID = '';
        this.solutions.filter(sol => sol.solutionID == pSolution.solutionID)[0].solutionDetails.filter(itm => itm.combinationID === pCombinationID)[0].molecularTypeMolecularID = '';
        this.solutions.filter(sol => sol.solutionID == pSolution.solutionID)[0].solutionDetails.filter(itm => itm.combinationID === pCombinationID)[0].molecularTypePic = '';
        this.solutions.filter(sol => sol.solutionID == pSolution.solutionID)[0].solutionDetails.filter(itm => itm.combinationID === pCombinationID)[0].noOfFilter = 1;
        this.solutions.filter(sol => sol.solutionID == pSolution.solutionID)[0].solutionDetails.filter(itm => itm.combinationID === pCombinationID)[0].totalStage = 1;
        this.solutions.filter(sol => sol.solutionID == pSolution.solutionID)[0].solutionDetails.filter(itm => itm.combinationID === pCombinationID)[0].customMediaSize = this.projectService.getCustomMediaSizeEmptyvalueStructure();
        this.solutions.filter(sol => sol.solutionID == pSolution.solutionID)[0].solutionDetails.filter(itm => itm.combinationID === pCombinationID)[0].moreInformation = this.projectService.getMoreInfoForSolutionEmptyvalueStructure();

    }

    selectStage(WhichStage, WhichSolution, WhichCombination) {
        switch (WhichStage) {
            case 1:
                var eleStage1 = document.getElementById('btnStage1For' + WhichSolution + WhichCombination);
                var eleStage2 = document.getElementById('btnStage2For' + WhichSolution + WhichCombination);
                var eleStage3 = document.getElementById('btnStage3For' + WhichSolution + WhichCombination);

                eleStage1.className = 'selectedStage-btn';
                eleStage2.className = 'unSelectedStage-btn';
                eleStage3.className = 'unSelectedStage-btn';
                break;
            case 2:
                var eleStage1 = document.getElementById('btnStage1For' + WhichSolution + WhichCombination);
                var eleStage2 = document.getElementById('btnStage2For' + WhichSolution + WhichCombination);
                var eleStage3 = document.getElementById('btnStage3For' + WhichSolution + WhichCombination);

                eleStage1.className = 'unSelectedStage-btn';
                eleStage2.className = 'selectedStage-btn';
                eleStage3.className = 'unSelectedStage-btn';
                break;
            case 3:
                var eleStage1 = document.getElementById('btnStage1For' + WhichSolution + WhichCombination);
                var eleStage2 = document.getElementById('btnStage2For' + WhichSolution + WhichCombination);
                var eleStage3 = document.getElementById('btnStage3For' + WhichSolution + WhichCombination);

                eleStage1.className = 'unSelectedStage-btn';
                eleStage2.className = 'unSelectedStage-btn';
                eleStage3.className = 'selectedStage-btn';
                break;
        }

        for (let i = 0; i < this.solutions.length; i++) {
            if (this.solutions[i].solutionID == WhichSolution) {
                if (this.solutions[i].solutionDetails.length > 0) {
                    for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                        if (this.solutions[i].solutionDetails[j].combinationID == WhichCombination) {
                            this.solutions[i].solutionDetails[j].totalStage = WhichStage;
                        }
                    }
                }
            }
        }

        if (this.solutions[WhichSolution - 1].solutionDetails[WhichCombination - 1].molecularID > 0) {
            this.toEnableDisableObj(WhichSolution, WhichCombination, 'disable');

            //Trigger Calculation
            this.triggerCalculation(WhichSolution, WhichCombination, false);
        }
    }

    moreInfo(solution, WhichSolID, WhichCombination) {
        var divName = 'divMoreInfoForSolDet' + WhichSolID + WhichCombination;
        let div = document.getElementById(divName);

        switch (solution.displayTypeForMoreInfo) {
            case "More Information":
                div.style.display = 'block';
                solution.displayTypeForMoreInfo = "Collapse";
                break;
            case "Collapse":
                div.style.display = 'none';
                solution.displayTypeForMoreInfo = "More Information";
                break;
        }
    }

    triggerCalculation(WhichSolution, WhichCombination, CheckAbleToAddSolDet) {
        this.sharedService.CalculationInProgress = true;
        this.sharedService.ServerData = this.sharedService.CompileDataForCalculation(this.projectService.projectdetails, WhichSolution);
        this.sharedService.CountTotalSeqForUploadingParams(this.sharedService.ServerData, "UPLOAD MCCLD PARAMS TO SERVER");
        this.PrepareToUploadParams(WhichSolution, WhichCombination, CheckAbleToAddSolDet);
    }

    PrepareToUploadParams(pWhichSolution, pWhichCombination, CheckAbleToAddSolDet) {
        var dataToUpload = this.sharedService.generateStr();
        console.log("PS20230321 Check: => UploadServerData2TempStringStorage - START=> " + new Date());
        this.projectService.UploadServerData2TempStringStorage(dataToUpload).subscribe(
            res => {
                console.log("PS20230321 Check: => UploadServerData2TempStringStorage - END=> " + new Date());
                if (res) {
                    this.sharedService.TempStringStorageTotalPass = this.sharedService.TempStringStorageTotalPass + 1;
                    this.sharedService.ServerDataReady = true;
                    this.sharedService.UploadingEntry = false;
                    if (this.sharedService.TempStringStorageTotalPass + this.sharedService.TempStringStorageTotalFail !== this.sharedService.TempStringStorageTotalSeq) {
                        this.sharedService.TempStringStorageCurrentSeq = this.sharedService.TempStringStorageCurrentSeq + 1;
                        this.PrepareToUploadParams(pWhichSolution, pWhichCombination, CheckAbleToAddSolDet);
                    } else {
                        if (this.sharedService.TempStringStorageTotalPass === this.sharedService.TempStringStorageTotalSeq) {
                            console.log("PS20230321 Check: => Perform CLD Calculation -START=> " + new Date());
                            this.projectService.PerformMCCLDCalculation(true, pWhichCombination, false, false).subscribe(data => {
                                console.log("PS20230321 Check: => Perform CLD Calculation -END=> " + new Date());
                                //Modified by PP(2023-10-24): Check for timeout of logincode - START
                                // if (data) {
                                //     this.getMoreInformationForSolutions(data);                     
                                //     if (CheckAbleToAddSolDet) {
                                //         //this.checkIfStillAbleToAddSolDets(data.SolutionResults[0].SolutionID);  //Modified by PS(2023-03-24): MCCLD 2023-Solution page: disable more than one media in one solution-START                    
                                //     }                               
                                // } else {
                                //     this.sharedService.CalculateMCCLDCompleted = false;
                                // }
                                if (data !== null) {
                                    if (data !== undefined) {

                                        this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'SUCCESS_CALCULATION').subscribe(result => {                       
                                            if (result) {}
                                        });

                                        this.getMoreInformationForSolutions(data);
                                        if (CheckAbleToAddSolDet) {
                                            //this.checkIfStillAbleToAddSolDets(data.SolutionResults[0].SolutionID);  //Modified by PS(2023-03-24): MCCLD 2023-Solution page: disable more than one media in one solution-START                    
                                        }
                                    } else {
                                        this.sharedService.CalculateMCCLDCompleted = false;
                                        this.toastr.error("Unable to calculate result. Please try again.", "");
                                    }
                                } else {
                                    this.sharedService.redirectToLoginPage();
                                    // this.userInfoService.userData.UserId = 0;
                                    // this.toastr.error('Session time out. Please login again.', '');
                                    // this.router.navigate(["login"]); 
                                }
                                //Modified by PP(2023-10-24): Check for timeout of logincode - END

                                this.toEnableDisableObj(pWhichSolution, pWhichCombination, 'enable');
                                this.sharedService.CalculationInProgress = false;
                            });
                        } else {
                        }
                    }
                } else {
                    this.sharedService.TempStringStorageTotalFail = this.sharedService.TempStringStorageTotalFail + 1;
                    this.sharedService.UploadingEntry = false;
                    this.sharedService.ServerDataReady = false;
                }
            },
            err => {
                this.sharedService.CalculationInProgress = false;
            }
        );
    }

    checkIfStillAbleToAddSolDets(pSolID) {
        for (let i = 0; i < this.solutions.length; i++) {
            if (this.solutions[i].solutionID == pSolID) {
                var totalCombinationGas = 0;
                for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                    totalCombinationGas = totalCombinationGas + this.solutions[i].solutionDetails[j].combinationGas.length;
                }
                if (totalCombinationGas < this.availableGas.length) {
                    this.addSolDetails(i);
                }
            }
        }
    }

    changeNoOfFilter(WhichSolution, WhichCombination) {
        if (this.solutions[WhichSolution - 1].solutionDetails[WhichCombination - 1].molecularID > 0) {
            var abc = 123;
            this.toEnableDisableObj(WhichSolution, WhichCombination, 'disable');

            //Trigger Calculation
            this.triggerCalculation(WhichSolution, WhichCombination, false);
        }
    }

    format(WhichField, pCustomMediaSize) {
        let tmpValue = 0
        switch (WhichField) {
            case "Height":
                //pSolDet.customMediaSize.height = this.sharedService.formatValue(parseFloat(pSolDet.customMediaSize.height), true);
                tmpValue = this.sharedService.convertLocaletoNumber(pCustomMediaSize.height, this.NumberFormat);
                pCustomMediaSize.height = this.sharedService.formatValue(tmpValue, true);
                break;

            case "Length":
                //pSolDet.customMediaSize.length = this.sharedService.formatValue(parseFloat(pSolDet.customMediaSize.length), true);
                tmpValue = this.sharedService.convertLocaletoNumber(pCustomMediaSize.length, this.NumberFormat);
                pCustomMediaSize.length = this.sharedService.formatValue(tmpValue, true);
                break;

            case "Depth":
                //pSolDet.customMediaSize.depth = this.sharedService.formatValue(parseFloat(pSolDet.customMediaSize.depth), true);
                tmpValue = this.sharedService.convertLocaletoNumber(pCustomMediaSize.depth, this.NumberFormat);
                pCustomMediaSize.depth = this.sharedService.formatValue(tmpValue, true);
                break;

            //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174 - START
            case "Diameter":
                tmpValue = this.sharedService.convertLocaletoNumber(pCustomMediaSize.diameter, this.NumberFormat);
                pCustomMediaSize.diameter = this.sharedService.formatValue(tmpValue, true);
                break;

            //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174 - END
        }
        //this.sharedService.formatValue(data.SolutionResults[0].Results[a].FrontVelocity.toFixed(2), true);
    }

    cleanCustomMedia(pElement, pCombinationID) {
        //this.solutions.filter(sol=>sol.solutionID==pElement.solutionID)[0].solutionDetails.filter(itm=>itm.combinationID===pCombinationID)[0].customMediaSize = this.projectService.getCustomMediaSizeEmptyvalueStructure();     
    }

    selectGroupOrType(selectedRec, GroupOrType) {
        switch (GroupOrType) {
            case "group":

                break;

            case "type":

                break;
        }
    }

    detectKeyChanges(WhichItem, pIndex) {
        switch (WhichItem) {

        }
    }

    toEnableDisableObj(WhichSolution, WhichCombination, Mode) {
        const NumOfFilterInputText = document.getElementById('txtNumFil' + WhichSolution + WhichCombination) as HTMLInputElement | null;

        //3 stages button
        const Stage1Btn = document.getElementById('btnStage1For' + WhichSolution + WhichCombination) as HTMLInputElement | null;
        const Stage2Btn = document.getElementById('btnStage2For' + WhichSolution + WhichCombination) as HTMLInputElement | null;
        const Stage3Btn = document.getElementById('btnStage3For' + WhichSolution + WhichCombination) as HTMLInputElement | null;

        if (NumOfFilterInputText != null || NumOfFilterInputText != undefined) {
            switch (Mode) {
                case "disable":
                    NumOfFilterInputText.disabled = true;

                    Stage1Btn.disabled = true;
                    Stage2Btn.disabled = true;
                    Stage3Btn.disabled = true;
                    break;
                case "enable":
                    NumOfFilterInputText.disabled = false;

                    Stage1Btn.disabled = false;
                    Stage2Btn.disabled = false;
                    Stage3Btn.disabled = false;
                    break;
            }
        }
    }

    getMoreInfoForContamination() {
        for (var x = 0; x < this.projectService.projectdetails.contamination.gasDetails.length; x++) {
            if (this.projectService.projectdetails.contamination.gasDetails[x].chemicalID > 0) {
                let ChemInfo = this.sharedService.getChemInfo(this.projectService.projectdetails.contamination.gasDetails[x].chemicalID); //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START        
                let newMoreInfo = this.projectService.getmoreInfoForGasEmptyvalueStructure();
                newMoreInfo.chemicalFormula = ChemInfo.chemicalFormula;
                newMoreInfo.molecularWeight = this.sharedService.formatValue(ChemInfo.molecularWeight, true);
                
                newMoreInfo.vapourPressureValue = this.sharedService.formatValue(ChemInfo.vapourPressureValue, true);
                newMoreInfo.boilingPoint = this.sharedService.formatValue(ChemInfo.boilingPoint, true);

                //pplim 20251002: vapourPressureValue & boilingPoint (no result)
                if (this.projectService.projectdetails.projectInfo.unitId == 2) {
                    newMoreInfo.vapourPressureValue = this.calculateService.ConvertVapourPa(this.sharedService.convertLocaletoNumber(ChemInfo.vapourPressureValue, this.NumberFormat), 'US');
                    newMoreInfo.vapourPressureValue = this.sharedService.formatValue(newMoreInfo.vapourPressureValue.toFixed(2), true);
                    newMoreInfo.boilingPoint = this.calculateService.ConvertTemperature(this.sharedService.convertLocaletoNumber(ChemInfo.boilingPoint, this.NumberFormat), 'US');
                    newMoreInfo.boilingPoint = this.sharedService.formatValue(newMoreInfo.boilingPoint, true);
                }

                newMoreInfo.casNo = ChemInfo.cas_no;
                this.projectService.projectdetails.contamination.gasDetails[x].moreInformation = newMoreInfo;
            }
        }
    }

    getMoreInformationForSolutions(data) {
        for (let i = 0; i < this.solutions.length; i++) {
            if (this.solutions[i].solutionID == data.SolutionResults[0].SolutionID) {
                for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                    for (let a = 0; a < data.SolutionResults[0].Results.length; a++) {
                        if (this.solutions[i].solutionDetails[j].combinationID == data.SolutionResults[0].Results[a].CombinationID) {
                            this.solutions[i].solutionDetails[j].moreInformation.effectiveMediaWeight = this.sharedService.formatValue(parseFloat(data.SolutionResults[0].Results[a].EffMediaWeight.toFixed(1)), true);
                            this.solutions[i].solutionDetails[j].moreInformation.frontVelocity = this.sharedService.formatValue(parseFloat(data.SolutionResults[0].Results[a].FrontVelocity.toFixed(2)), true);
                            this.solutions[i].solutionDetails[j].moreInformation.totalWeight = this.sharedService.formatValue(parseFloat(data.SolutionResults[0].Results[a].TotalWeight.toFixed(1)), true);
                            this.solutions[i].solutionDetails[j].moreInformation.contactTime = this.sharedService.formatValue(parseFloat(data.SolutionResults[0].Results[a].ContactTime.toFixed(2)), true);
                        }
                    }
                }
            }
        }
    }

    //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
    /* getChemInfo(pChemID: number) {
         var chemInfo: any;
         for (var x=0;x<this.AllDDLList.ApplicationContaminationFromServer.AMCChemical.length;x++) {
           if (pChemID == this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].ChemicalID) {
             chemInfo = {
               contamination_type : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Substance,
               chemical_id : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].ChemicalID,
               chemicalFormula : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Formula,
               vapourPressureValue : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Vp,
               molecularWeight : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Mw,
               boilingPoint : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Tbp,
               cas_no : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].CasNo,
               density : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].dL,
               refractiveIndex : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].RI,
               chemical_warning : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].ChemicalWarning,
               gasWarningColor : parseInt(this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Importancy)
             }
             break;
           }
         }
         return chemInfo
     }*/
    //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-END
    //Modified by PP(2023-02-14) : If still no media list comes down then continue looping - START
    // forceLoopForMediaLoading() {
    //     for (var x=0;x<5;x++) {
    //         if (this.ChemicalMediaList === undefined || this.FilterChemicals === undefined) {
    //             console.log("looped times : " + x);               
    //             this.checkIfMediaCompletesLoading();
    //         }
    //     }
    //     if (this.ChemicalMediaList === undefined || this.FilterChemicals === undefined) {
    //         console.log("after 5 timest of looping and still no media");
    //         //this.sharedService.RetrieveDDL(); //123
    //         //this.sharedService.FetchContamination_FilterGrouping(); //abc
    //     }
    // }
    //Modified by PP(2023-02-14) : If still no media list comes down then continue looping - END

    //Modified by PP(2023-06-15) : Cancel and [X] not working for Custom Media Size - START
    getCustomSizeFromSolDet(pCustomSize: any) {
        this.customMediaSizeForInput = this.projectService.getCustomMediaSizeEmptyvalueStructure();
        this.customMediaSizeForInput.depth = pCustomSize.depth;
        this.customMediaSizeForInput.height = pCustomSize.height;
        this.customMediaSizeForInput.length = pCustomSize.length;
        this.customMediaSizeForInput.diameter = pCustomSize.diameter; //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
        this.customMediaSizeForInput.shapeType = pCustomSize.shapeType; //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
    }

    getCustomSizeFromTmpArray(pCustomSize: any) {
        pCustomSize.depth = this.customMediaSizeForInput.depth;
        pCustomSize.height = this.customMediaSizeForInput.height;
        pCustomSize.length = this.customMediaSizeForInput.length;
        pCustomSize.diameter = this.customMediaSizeForInput.diameter; //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
        pCustomSize.shapeType = this.customMediaSizeForInput.shapeType; //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
    }

    triggerCancelFromCustomSize() {
        var abc = 123;
    }
    //Modified by PP(2023-06-15) : Cancel and [X] not working for Custom Media Size - END

    //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174 - START
    selectShape(shape: string, pSolutionID, pCombinationID) {
        this.selectedShape = shape;

        switch(shape) {
            case "rectangle":
                this.customMediaSizeForInput.shapeType =1;
            break;

            case "cylinder":
                this.customMediaSizeForInput.shapeType =2;
            break;
        }        
    }

    onShapeChange(pEvent: any, pSolutionID, pCombinationID) {
        if (pEvent.currentTarget.checked) { //Check
            //If single gas, disabled other gas Combination
            //Modified by PP(2023-02-09) : To cater for not getting multi gas alrogrithm if (pEvent.currentTarget.name.includes('Others')) {
          
        } else { //Uncheck
            for (let i = 0; i < this.solutions.length; i++) {
                if (this.solutions[i].solutionID == pSolutionID) {
                    for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                        if (this.solutions[i].solutionDetails[j].combinationID === pCombinationID) {
                            //this.solutions[i].solutionDetails.splice(j, 1);
                            //this.checkIfStillAbleToAddSolDets(pSolutionID);
                        }
                    }
                }
            }
        }
    }

    onShapeChangeNEW(WhichStage, WhichSolution, WhichCombination) {
        switch (WhichStage) {
            case 1:
                var eleStage1 = document.getElementById('btnStage1For' + WhichSolution + WhichCombination);
                var eleStage2 = document.getElementById('btnStage2For' + WhichSolution + WhichCombination);
                var eleStage3 = document.getElementById('btnStage3For' + WhichSolution + WhichCombination);

                eleStage1.className = 'selectedStage-btn';
                eleStage2.className = 'unSelectedStage-btn';
                eleStage3.className = 'unSelectedStage-btn';
                break;
            case 2:
                var eleStage1 = document.getElementById('btnStage1For' + WhichSolution + WhichCombination);
                var eleStage2 = document.getElementById('btnStage2For' + WhichSolution + WhichCombination);
                var eleStage3 = document.getElementById('btnStage3For' + WhichSolution + WhichCombination);

                eleStage1.className = 'unSelectedStage-btn';
                eleStage2.className = 'selectedStage-btn';
                eleStage3.className = 'unSelectedStage-btn';
                break;
            case 3:
                var eleStage1 = document.getElementById('btnStage1For' + WhichSolution + WhichCombination);
                var eleStage2 = document.getElementById('btnStage2For' + WhichSolution + WhichCombination);
                var eleStage3 = document.getElementById('btnStage3For' + WhichSolution + WhichCombination);

                eleStage1.className = 'unSelectedStage-btn';
                eleStage2.className = 'unSelectedStage-btn';
                eleStage3.className = 'selectedStage-btn';
                break;
        }

        for (let i = 0; i < this.solutions.length; i++) {
            if (this.solutions[i].solutionID == WhichSolution) {
                if (this.solutions[i].solutionDetails.length > 0) {
                    for (let j = 0; j < this.solutions[i].solutionDetails.length; j++) {
                        if (this.solutions[i].solutionDetails[j].combinationID == WhichCombination) {
                            this.solutions[i].solutionDetails[j].totalStage = WhichStage;
                        }
                    }
                }
            }
        }

        if (this.solutions[WhichSolution - 1].solutionDetails[WhichCombination - 1].molecularID > 0) {
            this.toEnableDisableObj(WhichSolution, WhichCombination, 'disable');

            //Trigger Calculation
            this.triggerCalculation(WhichSolution, WhichCombination, false);
        }
    }
     //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174 - END

}

